import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { color, font } from "../../theme/tokens";
import { Team } from "../../data/HeroSpotlight";
import Portrait from "../layout/Portrait";

const Strip = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 24px;

  @media (max-width: 1100px) { grid-template-columns: repeat(4, 1fr); }
  @media (max-width: 780px)  { grid-template-columns: repeat(3, 1fr); }
  @media (max-width: 560px)  { grid-template-columns: repeat(2, 1fr); gap: 20px; }
`;

const Person = styled(Link)`
  text-decoration: none;
  display: block;
`;

const StyledPortrait = styled(Portrait)`
  img {
    filter: grayscale(1);
    transition: filter 260ms ease, transform 400ms ease;
  }

  ${Person}:hover & img {
    filter: grayscale(0);
    transform: scale(1.03);
  }
`;

const Name = styled.div`
  font-family: ${font.display};
  font-size: 17px;
  font-weight: 500;
  color: ${color.inkStrong};
  margin-top: 14px;
`;

const Role = styled.div`
  font-family: ${font.body};
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${color.inkMuted};
  margin-top: 5px;
`;

/** Face row under the People band — six across, links through to /team. */
export default function TeamStrip({ limit = 6 }) {
  const people = (Team || []).slice(0, limit);

  return (
    <Strip>
      {people.map((m, i) => (
        <Person to="/team" key={i}>
          <StyledPortrait src={m.imageUrl} name={m.name} />
          <Name>{m.name}</Name>
          <Role>{m.position}</Role>
        </Person>
      ))}
    </Strip>
  );
}
